import React from 'react';

const ButtonSection = ({ setShowModal }) => {
    return (
        <div className="action__btn my-5">
            <button className='btn bg-[#090833] btn-xl mx-2' onClick={() => setShowModal(true)}>
                Watch now
            </button>
            <button className='btn bg-[#090833] btn-xl' onClick={() => setShowModal(true)}>Download</button>

            {/* <button className='btn bg-[#090833] btn-xl mx-2' onClick={() => window.open('https://www.highwaycpmrevenue.com/g8vmxuare?key=913bbb2d21aed66d055f4af400c46177')}>
                Watch now
            </button>
            <button className='btn bg-[#090833] btn-xl' onClick={() => window.open('https://www.highwaycpmrevenue.com/g8vmxuare?key=913bbb2d21aed66d055f4af400c46177')}>Download</button> */}

            {/* <button className='btn bg-[#090833] btn-xl mx-2' onClick={() => window.open('https://credulityicicle.com/y06ukbd5?key=033f0ca793769c31fd514d764a889f44', '_blank')}>
                    Watch now
                </button>
                <button className='btn bg-[#090833] btn-xl' onClick={() => window.open('https://credulityicicle.com/v29m6j2i?key=784477d0c2757c4c5485d6ca3cca4ac1', '_blank')}>Download</button> */}
        </div>
    );
};

export default ButtonSection;